/**
 * @generated SignedSource<<b6c17a2a35903912b25e380f58630851>>
 * @relayHash 36f07a23042e3d8b2713f56ed7f44023
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 06a7ef491f56ed3890b2d1e700a2513a829a8028798213c4053e72e8fb5d0c21

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareListAppQuery } from './JiraSoftwareListAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareListAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "06a7ef491f56ed3890b2d1e700a2513a829a8028798213c4053e72e8fb5d0c21",
    "metadata": {},
    "name": "JiraSoftwareListAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
